<template>
  <div>
    <!-- User selection label -->
    <label
      for="user-select"
      class="block mb-1.5 text-sm font-medium text-gray-900"
    >
      Bruger
    </label>
    <!-- User selection dropdown -->
    <select
      id="user-select"
      v-model="selectedReplacementIdLocal"
      name="user"
      class="bg-neutral-50 border border-neutral-300 border-solid text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
    >
      <option value="">Ingen afløser</option>
      <option v-for="user in users" :key="user.id" :value="user.id">
        {{ user.first_name }} {{ user.last_name }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from "vue";

// Define props
const props = defineProps({
  selectedReplacementId: {
    type: [String, Number],
    default: "",
  },
  users: {
    type: Array,
    required: true,
  },
});

// Define emits
const emit = defineEmits(["update:selectedReplacementId"]);

// Local state
const selectedReplacementIdLocal = ref(props.selectedReplacementId);

// Watchers to sync local state with props
watch(selectedReplacementIdLocal, (newValue) => {
  emit("update:selectedReplacementId", newValue);
});

watch(
  () => props.selectedReplacementId,
  (newValue) => {
    selectedReplacementIdLocal.value = newValue;
  }
);
</script>
